import './beneficiary-termination-modal-controller';